import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

import useHomeStore from "./ZustandStore/useHomeStore";
import { set, useForm } from "react-hook-form";
import { useDebounce } from "use-debounce";
// assets / images / logo / lazmy - offical - logo.png;

const HeaderOne = ({ apiLinks, apiCategories }) => {
  const { cartCount, wishlistCount, fetchCountProduct, fetchSearchBtn } =
    useHomeStore();
  useEffect(() => {
    fetchCountProduct();
  }, []);
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  // Set the default language
  const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  // Set the default currency
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
  };

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);

  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };

  const handleCloseDropDown = () => {
    setActiveCategory(false);
  };

  const [activeIndexCat, setActiveIndexCat] = useState(null);

  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  // Authentication

  const navigate = useNavigate();
  // Check if the user is logged in (token exists in localStorage)
  const isAuthenticated = !!localStorage.getItem("accessToken");

  const username = sessionStorage.getItem("name");

  const handleLogout = () => {
    // Remove the token and user object from localStorage
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user"); // Remove 'user', not 'username'
    navigate("/login"); // Redirect to the login page
  };

  const links = [
    {
      label: "Home",
      to: "/",
    },
    {
      label: "Shop",
      to: "/shop",
    },
  ];

  // searchbar
  const { register, handleSubmit, watch, setValue, reset } = useForm();
  const [debouncedQuery] = useDebounce(watch("query"), 500);
  const { searchResults, fetchSearchResults, error } = useHomeStore();
  const [showDropdown, setShowDropdown] = useState(false);
  sessionStorage.setItem("value", debouncedQuery);
  console.log("value", debouncedQuery);

  const location = useLocation();

  const onSubmit = async () => {
    if (debouncedQuery) {
      fetchSearchResults(debouncedQuery);
    }
  };

  useEffect(() => {
    if (debouncedQuery) {
      fetchSearchResults(debouncedQuery);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  }, [debouncedQuery, fetchSearchResults]);

  // Clear search input and close dropdown on location change
  useEffect(() => {
    setValue("query", ""); // Clear the search input
    setShowDropdown(false); // Close the dropdown
  }, [location, setValue]);

  const showSearchBarPages = ["/", "/shop"];

  const showSearchBar =
    showSearchBarPages.includes(location.pathname) ||
    location.pathname.startsWith("/product/");

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
        onClick={() => {
          handleMenuToggle();
          setActiveIndex(null);
        }}
      />
      {/* ==================== Search Box Start Here ==================== */}
      <form
        action="#"
        onSubmit={handleSubmit(onSubmit)} // Handle form submission
        className={`search-box ${activeSearch && "active"}`}
      >
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for a product or brand"
              {...register("query")} // Register the input field with React Hook Form
              onChange={(e) => {
                setValue("query", e.target.value); // Update the query state
                setShowDropdown(true); // Show the dropdown when input changes
              }}
            />
            <Link
              className={` w-48 h-48 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8 bg-main-600`}
              onClick={(e) => {
                setValue("query", "");
                handleSearchToggle();
                if (!debouncedQuery || !debouncedQuery.trim()) {
                  e.preventDefault();
                  return;
                }

                const selectedResult = searchResults.find(
                  (result) =>
                    result.title.toLowerCase() === debouncedQuery.toLowerCase()
                );

                if (selectedResult) {
                  fetchSearchBtn(selectedResult.slug);
                }

                if (selectedResult) {
                  fetchSearchBtn(selectedResult.slug);
                } else {
                  e.preventDefault();
                  navigate("/category/not-found");
                }

                setShowDropdown(false);
              }}
              to={`/category/${
                searchResults.find(
                  (result) =>
                    result.title.toLowerCase() === debouncedQuery.toLowerCase()
                )?.slug
              }`}
            >
              <i className="ph ph-magnifying-glass" />
            </Link>

            {/* Dropdown to display search results */}
            {showDropdown && searchResults.length > 0 && (
              <div
                className="dropdown-results position-absolute w-100 bg-white text-black mt-2 max-h-60 overflow-y-auto rounded shadow-lg"
                style={{
                  zIndex: 9999,
                  maxHeight: "200px", // Limit height for mobile
                }}
              >
                <ul className="m-0 p-0 border border-gray">
                  {searchResults.map((result, index) => (
                    <li
                      key={index}
                      className="dropdown-item hover-text-white hover-bg-main-600"
                      onClick={() => {
                        setShowDropdown(false); // Immediately close the dropdown
                        setValue("query", result.title); // Update query input
                        handleSubmit(onSubmit)(); // Trigger search submission
                      }}
                      style={{
                        padding: "12px 16px", // Larger touch targets
                        cursor: "pointer",
                        listStyle: "none",
                        fontSize: "16px", // Mobile-friendly text size
                        transition: "all 0.3s ease",
                      }}
                    >
                      <p className="m-0">{result.title}</p>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Show error message if there's any error */}
            {error && (
              <div className="error-message text-red-500 mt-2">{error}</div>
            )}
          </div>
        </div>
      </form>

      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="link">
            <img src="assets/images/logo/header_logo.png" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              {links.map((link, index) => (
                <li
                  key={link.id}
                  onClick={() => handleMenuClick(index)}
                  className={`on-hover-item nav-menu__item ${
                    link.submenu ? "has-submenu" : ""
                  } ${activeIndex === index ? "d-block" : ""}`}
                >
                  {link.badge && (
                    <span className="badge-notification bg-warning-600 text-white text-sm py-2 px-8 rounded-4">
                      {link.badge}
                    </span>
                  )}
                  <Link
                    to={link.to || "#"}
                    className="nav-menu__link"
                    onClick={!link.submenu ? () => setActiveIndex(null) : null}
                  >
                    {link.label}
                  </Link>
                  {link.submenu && (
                    <ul
                      className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                        activeIndex === index ? "open" : ""
                      }`}
                    >
                      {link.submenu.map((subLink, subIndex) => (
                        <li
                          key={subLink.id}
                          className="common-dropdown__item nav-submenu__item"
                        >
                          <Link
                            to={subLink.to}
                            className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                            onClick={() => setActiveIndex(null)}
                          >
                            {subLink.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
              {apiLinks.map((link) => {
                return (
                  <li className="on-hover-item nav-menu__item " key={link.id}>
                    <Link to="#" className="nav-menu__link">
                      {link.title}
                    </Link>
                  </li>
                );
              })}
            </ul>

            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Top Start ========================= */}
      <div
        className="header-top flex-between"
        style={{ background: "#ff4c01" }}
      >
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              <li className="border-right-item">
                <Link
                  to="/about-us"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  About us
                </Link>
              </li>
              <li className="border-right-item">
                <Link
                  to="/contact-us"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Contact us
                </Link>
              </li>

              <li className="border-right-item">
                <Link
                  to="/free-delivery"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Free Delivery
                </Link>
              </li>
              <li className="border-right-item">
                <Link
                  to="/returns-policy"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Returns Policy
                </Link>
              </li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="text-white text-sm py-8">
                  Help Center
                </Link>
                <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-headset" />
                      </span>
                      Call Center
                    </Link>
                  </li>
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-chat-circle-dots" />
                      </span>
                      Live Chat
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="border-right-item">
                {isAuthenticated ? (
                  <button
                    onClick={handleLogout}
                    className="text-white text-sm py-8 flex-align gap-6"
                  >
                    <span className="icon text-md d-flex">
                      <i className="ph ph-sign-out" />
                    </span>
                    <span className="hover-text-decoration-underline">
                      Logout
                    </span>
                  </button>
                ) : (
                  <Link
                    to="/login"
                    className="text-white text-sm py-8 flex-align gap-6"
                  >
                    <span className="icon text-md d-flex">
                      <i className="ph ph-user-circle" />
                    </span>
                    <span className="hover-text-decoration-underline">
                      Login
                    </span>
                  </Link>
                )}
              </li>
              <li className="border-right-item">
                {isAuthenticated ? (
                  <span className="text-white text-sm py-8 flex-align gap-6">
                    <span className="icon text-md d-flex">
                      <i className="ph ph-user-circle" />
                    </span>
                    <span className="text-capitalize">{username}</span>
                  </span>
                ) : (
                  <Link
                    to="/phone-number-verfication"
                    className="text-white text-sm py-8 flex-align gap-6"
                  >
                    <span className="icon text-md d-flex">
                      <i className="ph ph-user-circle" />
                    </span>
                    <span className="hover-text-decoration-underline">
                      Signup
                    </span>
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start ========================= */}
      <header className="header-middle  border-bottom border-gray-100">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img
                  src="/assets/images/logo/header_logo.png"
                  alt="Header Logo"
                />
              </Link>
            </div>
            {/* Logo End  */}
            {/* form location Start */}
            {(isAuthenticated || showSearchBar) && (
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex-align flex-wrap form-location-wrapper"
              >
                <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
                  <div className="search-form__wrapper position-relative">
                    <input
                      type="text"
                      className="search-form__input common-input py-13 ps-16 pe-18 pe-44"
                      placeholder="Search for a product or brand"
                      {...register("query", {
                        required: "Search term is required.",
                      })}
                      onChange={(e) => {
                        setValue("query", e.target.value);
                        if (!e.target.value) setShowDropdown(false);
                      }}
                    />

                    <Link
                      onClick={(e) => {
                        setValue("query", "");
                        if (!debouncedQuery || !debouncedQuery.trim()) {
                          e.preventDefault();
                          return;
                        }

                        const selectedResult = searchResults.find(
                          (result) =>
                            result.title.toLowerCase() ===
                            debouncedQuery.toLowerCase()
                        );

                        if (selectedResult) {
                          fetchSearchBtn(selectedResult.slug);
                        } else {
                          e.preventDefault();
                          navigate("/category/not-found");
                        }

                        setShowDropdown(false);
                      }}
                      to={`/category/${
                        searchResults.find(
                          (result) =>
                            result.title.toLowerCase() ===
                            debouncedQuery.toLowerCase()
                        )?.slug
                      }`}
                      style={{ background: "#ff4c01" }}
                      className="w-48 btn h-48 rounded-top-bottom-right flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0"
                    >
                      <i className="ph ph-magnifying-glass" />
                    </Link>

                    {/* Dropdown to display search results */}
                    {showDropdown && searchResults.length > 0 && (
                      <div
                        className="dropdown-results position-absolute w-100 bg-white text-black mt-2 max-h-60 overflow-auto"
                        style={{
                          zIndex: "99999999999999999999999999999",
                        }}
                      >
                        <ul className="m-0 p-0 border border-gray">
                          {searchResults.map((result) => (
                            <li
                              key={result.id}
                              className="dropdown-item hover-text-white hover-bg-main-600"
                              onClick={() => {
                                setValue("query", result.title); // Set query to selected result
                                setShowDropdown(false); // Close the dropdown
                              }}
                              style={{
                                padding: "8px",
                                paddingInline: "12px",
                                cursor: "pointer",
                                listStyle: "none",
                                transition: "all 0.3s ease",
                              }}
                            >
                              <Link
                                className="text-black w-100"
                                to={`/category/${result.slug}`}
                              >
                                {result.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Show error message if there's any error */}
                    {error && (
                      <div className="error-message text-red-500 mt-2">
                        {error}
                      </div>
                    )}

                    {/* Show validation error */}
                  </div>
                </div>
              </form>
            )}

            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              {!isAuthenticated ? (
                ""
              ) : (
                <div className="flex-align flex-wrap gap-12">
                  <Link to="/orders" className="flex-align gap-2  item-hover ">
                    <span className="text-2xl mb-2 text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-user-circle" />
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Account & Orders
                    </span>
                  </Link>
                  <Link to="/wishlist" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      <span
                        className="w-16 h-16 flex-center rounded-circle  text-white text-xs position-absolute top-n6 end-n4"
                        style={{ background: "#ff4c01" }}
                      >
                        {wishlistCount}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Wishlist
                    </span>
                  </Link>
                  <Link to="/cart" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      <span
                        className="w-16 h-16 flex-center rounded-circle  text-white text-xs position-absolute top-n6 end-n4"
                        style={{ background: "#ff4c01" }}
                      >
                        {cartCount}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Cart
                    </span>
                  </Link>
                </div>
              )}
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header
        className={`header bg-white border-bottom  ${scroll && "fixed-header"}`}
      >
        <div className="container container-lg">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align ">
              {/* Category Dropdown Start */}
              {(isAuthenticated || showSearchBar) && (
                <div className="category on-hover-item">
                  <button
                    onClick={handleCategoryToggle}
                    type="button"
                    className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-heading"
                  >
                    <span className="icon text-2xl d-xs-flex d-none">
                      <i className="ph ph-dots-nine" />
                    </span>
                    <span className="d-sm-flex d-none">All</span> Categories
                    <span className="arrow-icon d-flex fw-bolder">
                      <i className="ph ph-caret-down fw-bolder" />
                    </span>
                  </button>
                  <div
                    className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper  ${
                      activeCategory && "active"
                    }`}
                  >
                    <button
                      onClick={() => {
                        handleCategoryToggle();
                        setActiveIndexCat(null);
                      }}
                      type="button"
                      className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                    >
                      <i className="ph ph-x" />
                    </button>
                    {/* Logo Start */}
                    <div className="logo px-16 d-lg-none d-block">
                      <Link to="/" className="link">
                        <img
                          src="assets/images/logo/header_logo.png"
                          alt="Logo"
                        />
                      </Link>
                    </div>
                    {/* Logo End */}
                    <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-hidden">
                      {apiCategories?.map((category, index) => (
                        <li
                          key={category.id}
                          className={`has-submenus-submenu ${
                            activeIndexCat === index ? "active" : ""
                          }`}
                        >
                          <Link
                            to="#"
                            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                            onClick={() => handleCatClick(index)}
                          >
                            <span onClick={() => handleCatClick(index)}>
                              {category.categoryName}
                            </span>
                            <span className="icon text-md d-flex ms-auto">
                              <i className="ph ph-caret-right" />
                            </span>
                          </Link>
                          <div
                            className={`submenus-submenu py-16 ${
                              activeIndexCat === index ? "open" : ""
                            }`}
                          >
                            <h6 className="text-lg px-16 submenus-submenu__title">
                              <Link
                                to={`/category/${category.slug}`}
                                onClick={() => handleCloseDropDown()}
                              >
                                {category.categoryName}
                              </Link>
                            </h6>
                            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                              {category.subCategories?.map((subCategory) => (
                                <li key={subCategory.id}>
                                  <Link
                                    to={`/category/${subCategory.slug}`}
                                    onClick={() => handleCloseDropDown()}
                                  >
                                    {subCategory.categoryName}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {(isAuthenticated || showSearchBar) && (
                  <ul className="nav-menu flex-align">
                    {links.map((item) => (
                      <li
                        className="nav-menu__item on-hover-item"
                        // has-submenu
                        key={item.id}
                      >
                        <Link to={item.to} className="nav-menu__link">
                          {item.label}
                        </Link>
                      </li>
                    ))}
                    {apiLinks.map((link, index) => (
                      <li
                        className="on-hover-item nav-menu__item"
                        key={link.id}
                      >
                        <Link
                          to={`/salespages/${link.slug}`}
                          className="nav-menu__link"
                        >
                          {link.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            {(isAuthenticated || showSearchBar) && (
              <div className="header-right flex-align">
                <div className="me-16 d-lg-none d-block">
                  <div className="flex-align flex-wrap gap-12">
                    <button
                      onClick={handleSearchToggle}
                      type="button"
                      className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                    >
                      <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                        <i className="ph ph-magnifying-glass" />
                      </span>
                    </button>
                    {isAuthenticated && (
                      <>
                        <Link to="/orders">
                          <button className="flex-align gap-4 item-hover">
                            <span className="text-2xl mb-2 text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                              <i className="ph ph-user-circle" />
                            </span>
                            <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                              Account & Orders
                            </span>
                          </button>
                        </Link>
                        <Link
                          to="/wishlist"
                          className="flex-align gap-4 item-hover"
                        >
                          <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                            <i className="ph ph-heart" />
                            <span
                              className="w-16 h-16 flex-center rounded-circle text-white text-xs position-absolute top-n6 end-n4"
                              style={{ background: "#ff4c01" }}
                            >
                              {wishlistCount}
                            </span>
                          </span>
                          <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                            Wishlist
                          </span>
                        </Link>
                        <Link
                          to="/cart"
                          className="flex-align gap-4 item-hover"
                        >
                          <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                            <i className="ph ph-shopping-cart-simple" />
                            <span
                              className="w-16 h-16 flex-center rounded-circle text-white text-xs position-absolute top-n6 end-n4"
                              style={{ background: "#ff4c01" }}
                            >
                              {cartCount}
                            </span>
                          </span>
                          <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                            Cart
                          </span>
                        </Link>
                      </>
                    )}
                  </div>
                </div>
                <button
                  onClick={handleMenuToggle}
                  type="button"
                  className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
                >
                  <i className="ph ph-list" />
                </button>
              </div>
            )}
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderOne;
